// // import React from 'react';
// // import { Box, Typography, Button } from '@mui/material';
// // import RoomIcon from '@mui/icons-material/Room';
// // import { useClientGeoLocation } from '../../hooks/useClientGeoLocation';


// // export default function LocationPermissionBanner() {
// //   const { permissionState, requestLocation } = useClientGeoLocation();

// //   if (permissionState === 'granted' || permissionState === 'unsupported') {
// //     return null;
// //   }

// //   const isDenied = permissionState === 'denied';

// //   return (
// //     <Box
// //       sx={{
// //         display: 'flex',
// //         alignItems: 'center',
// //         justifyContent: 'space-between',
// //         gap: 2,
// //         px: 2,
// //         py: 1.25,
// //         bgcolor: '#FFFAF0',
// //         border: '1px solid #FBD38D',
// //         borderRadius: '10px',
// //         mb: 2,
// //       }}
// //     >
// //       <Box display="flex" alignItems="center" gap={1}>
// //         <RoomIcon sx={{ fontSize: 18, color: '#C05621' }} />
// //         <Typography sx={{ fontSize: 13, color: '#C05621' }}>
// //           {isDenied
// //             ? "Location access is blocked — enable it in your browser's site settings to log precise location for activity records."
// //             : 'Allow location access so activity logs can record precise city and coordinates.'}
// //         </Typography>
// //       </Box>

// //       {!isDenied && (
// //         <Button
// //           size="small"
// //           onClick={requestLocation}
// //           sx={{ textTransform: 'none', fontWeight: 700, whiteSpace: 'nowrap' }}
// //         >
// //           Allow Location
// //         </Button>
// //       )}
// //     </Box>
// //   );
// // }


// import React from 'react';
// import { Box, Typography, Button } from '@mui/material';
// import RoomIcon from '@mui/icons-material/Room';
// import { useClientGeoLocation } from '../../hooks/useClientGeoLocation';
// // import { useClientGeoLocation } from '../hooks/useClientGeoLocation';

// export default function LocationPermissionBanner() {
//   const { permissionState, requestLocation } = useClientGeoLocation();

//   if (permissionState === 'granted' || permissionState === 'unsupported') {
//     return null;
//   }

//   const isDenied = permissionState === 'denied';

//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'space-between',
//         gap: 2,
//         px: 2,
//         py: 1.25,
//         bgcolor: '#FFFAF0',
//         border: '1px solid #FBD38D',
//         borderRadius: '10px',
//         mb: 2,
//       }}
//     >
//       <Box display="flex" alignItems="center" gap={1}>
//         <RoomIcon sx={{ fontSize: 18, color: '#C05621' }} />
//         <Typography sx={{ fontSize: 13, color: '#C05621' }}>
//           {isDenied
//             ? "Location access is blocked — enable it in your browser's site settings, then refresh."
//             : 'Allow location access so activity logs can record precise city and coordinates.'}
//         </Typography>
//       </Box>

//       {isDenied ? (
//         <Button
//           size="small"
//           onClick={() => window.location.reload()}
//           sx={{ textTransform: 'none', fontWeight: 700, whiteSpace: 'nowrap' }}
//         >
//           I've enabled it — Refresh
//         </Button>
//       ) : (
//         <Button
//           size="small"
//           onClick={requestLocation}
//           sx={{ textTransform: 'none', fontWeight: 700, whiteSpace: 'nowrap' }}
//         >
//           Allow Location
//         </Button>
//       )}
//     </Box>
//   );
// }


import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import RoomIcon from '@mui/icons-material/Room';
import { useClientGeoLocation } from '../../hooks/useClientGeoLocation';
// import { useClientGeoLocation } from '../hooks/useClientGeoLocation';

export default function LocationPermissionBanner() {
  const { permissionState, requestLocation } = useClientGeoLocation();

  // Only show the banner when we can actually still ask —
  // hide it entirely once granted, denied, or unsupported.
  if (permissionState !== 'prompt') {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        px: 2,
        py: 1.25,
        bgcolor: '#FFFAF0',
        border: '1px solid #FBD38D',
        borderRadius: '10px',
        mb: 2,
      }}
    >
      <Box display="flex" alignItems="center" gap={1}>
        <RoomIcon sx={{ fontSize: 18, color: '#C05621' }} />
        <Typography sx={{ fontSize: 13, color: '#C05621' }}>
          Allow location access so activity logs can record precise city and coordinates.
        </Typography>
      </Box>

      <Button
        size="small"
        onClick={requestLocation}
        sx={{ textTransform: 'none', fontWeight: 700, whiteSpace: 'nowrap' }}
      >
        Allow Location
      </Button>
    </Box>
  );
}